import React from 'react'
// libs
import { change } from 'redux-form'
import { useDispatch } from 'react-redux'
// types
import { AttachmentType, Attachment, LinkData } from './types'

type FieldInput = { value: any; onChange: (v: any) => void; name: string }

export const useDocLinkValue = ({
  input,
  form,
  onAfterClear,
  onAfterLinkSet
}: {
  input: FieldInput
  form: string
  onAfterClear?: () => void
  onAfterLinkSet?: () => void
}) => {
  const dispatch = useDispatch()

  const [attachment, setAttachment] = React.useState<Attachment | null>(input.value || null)

  React.useEffect(() => {
    if (!input.value?._pending) {
      setAttachment(input.value || null)
    }
  }, [input.value])

  const setValue = (value: Attachment | null) => {
    setAttachment(value)
    dispatch(change(form, input.name, value))
  }

  const clearField = () => {
    setValue(null)
    onAfterClear?.()
  }

  const addLink = ({ linkName, linkTarget }: LinkData) => {
    setValue({ title: linkName || undefined, url: linkTarget.trim(), type: AttachmentType.Link })
    onAfterLinkSet?.()
  }

  return { attachment, setAttachment, setValue, clearField, addLink }
}
